import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ImportExportIcon(props: IconProps) {
    return <Icon {...props} iconKey={"import_export"}/>
}
